import { defineMessages } from 'react-intl';

export default defineMessages({
  errorTitleDefault: {
    id: 'common.errorTitleDefault',
    defaultMessage: 'Avviso',
    description: 'Title of error default',
  },
  errorDescriptionDefault: {
    id: 'common.errorDescriptionDefault',
    defaultMessage: 'Si è verificato un errore, si prega di riprovare',
    description: 'Description of error default',
  },
  errorMigratoDefault: {
    id: 'common.migrato',
    defaultMessage:
      'Ti abbiamo inviato tramite e-mail la password provvisoria da inserire nel campo "Vecchia Password"',
    description: 'Description of error default',
  },
  errorTitlePopup: {
    id: 'common.errorTitlePopup',
    defaultMessage: 'Attenzione!',
    description: 'Title of popup error',
  },
  requiredMessage: {
    id: 'common.requiredMessage',
    defaultMessage: '*Campi obbligatori',
    description: 'Message for required input text field',
  },
  errorFieldsNotFill: {
    id: 'common.errorFieldsNotFill',
    defaultMessage: 'Compila tutti i campi',
    description: 'Error message fields not fill',
  },
  errorFillAtLeastOneField: {
    id: 'common.errorFillAtLeastOneField',
    defaultMessage: 'Compila almeno un campo',
    description: 'Error message fill at least one field',
  },
  errorCantOpenLink: {
    id: 'common.errorCantOpenLink',
    defaultMessage: "Non è possibile aprire l'URL: {url}",
    description: 'Error message when is not possible opening url',
  },
  errorCantOpenFile: {
    id: 'common.errorCantOpenFile',
    defaultMessage: 'Non è possibile aprire il file: {file}',
    description: 'Error message when is not possible opening file',
  },
  errorFieldMifid: {
    id: 'homeOnboardingSelfMifidSurvey.toastErrorMifid',
    defaultMessage: 'Alcuni campi non sono stati compilati correttamente',
  },
  errorFieldAml: {
    id: 'homeOnboardingSelfAmlSurvey.toastErrorAml',
    defaultMessage: 'Alcuni campi non sono stati compilati correttamente',
  },
  errorNotMigratedUserWeb: {
    id: 'common.errorNotMigratedUserWeb',
    defaultMessage:
      'Gentile Cliente per effettuare il primo accesso clicca qui e segui le indicazioni riportate nella schermata d\'accesso:  <a>qui</a>',
    description: 'Error description for not migrated user web side',
  },
  usernameNotValid:{
    id: 'common.usernameNotValid',
    defaultMessage:
      'Username non valida. Si prega di verificare',
    description: 'Error description for not migrated user web side',
  },
  errorNotMigratedUserMobile: {
    id: 'common.errorNotMigratedUserMobile',
    defaultMessage:
      'Gentile Cliente per effettuare il primo accesso clicca qui e segui le indicazioni riportate nella schermata d\'accesso: {url}',
    description: 'Error description for not migrated user mobile side',
  },
  errorExpiredToken: {
    id: 'common.errorExpiredToken',
    defaultMessage: 'Sessione scaduta, si prega di accedere di nuovo',
    description: 'Error message when token is expired',
  },
  fieldNotValid: {
    id: 'common.fieldNotValid',
    defaultMessage: 'Risposta non valida',
    description: 'Invalid answers',
  },
  errorSchedaProdottoNotAvailable: {
    id: 'common.errorSchedaProdottoNotAvailable',
    defaultMessage: 'Scheda prodotto non disponibile',
    description: 'Error message when scheda prodotto is not available',
  },
  errorTitlePasswordVecchia: {
    id: 'common.errorTitlePasswordVecchia',
    defaultMessage: 'Avviso',
    description: 'Title of error default',
  },
  errorDescriptionPasswordVecchia: {
    id: 'common.errorDescriptionPasswordVecchia',
    defaultMessage:
      'La Vecchia password o il codice provvisorio non sono corretti',
    description: 'Title of error default',
  },
  errorInvalidUserCode: {
    id: 'common.errorInvalidUserCode',
    defaultMessage: 'Il Codice Utente inserito non è corretto',
    description: 'Error message for invalid user code',
  },
  errorInvalidUsername: {
    id: 'common.errorInvalidUsername',
    defaultMessage: 'Username non valida. Si prega di verificare',
    description: 'Error message for invalid username',
  },
});
